import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import App from "@/App";
import { CartProvider } from "@/context/CartContext";
import { FxRatesProvider } from "@/context/FxRatesContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <FxRatesProvider>
      <CartProvider>
        <App />
      </CartProvider>
    </FxRatesProvider>
  </React.StrictMode>,
);
